<script lang="ts">
  import Gallery from "$lib/components/episodes/ContributionGallery.svelte";
  import { gallery_date } from "$lib/dates";
  import { get_pattern } from "$lib/utilities";

  // data import
  import type { PageData } from "./$types";
  export let data: PageData;
</script>

<slot />

{#if data.meta}
  <div class="description">
    {#if data.meta.title}
      <h2 style:background={get_pattern()}>
        {#if data.meta.status === "private"}
          Private:
        {/if}
        {data.meta.title}
      </h2>
    {/if}
    {#if data.meta.description}
      <div class="desc">
        {data.meta.description}
      </div>
    {/if}
    {#if data.meta.date_created || data.meta.date_updated}
      <div class="meta" style:background={get_pattern()}>
        <span>
          Created {gallery_date(data.meta.date_created ?? "")}
        </span>

        {#if data.meta.date_updated}
          <span>
            Updated {gallery_date(data.meta.date_updated ?? "")}
          </span>
        {/if}
      </div>
    {/if}
  </div>
{/if}
{#if (data.contributions ?? []).length > 0 && data.contributions}
  <Gallery
    gallery={data.contributions}
    context="search"
    base="/community/{data.member.handle}/galleries/{data.uuid}"
  />
{:else}
  <section>
    <p>It looks like there are no contributions in this gallery.</p>
  </section>
{/if}

<style>
  .desc {
    padding: 1rem;
    color: var(--title);
    line-height: 1.6;
  }

  .meta {
    display: flex;
    font-size: 0.8rem;
    font-weight: bold;
    color: var(--offDark);
    justify-content: center;
    gap: 1.5rem;
    padding: 1rem;
    border-top: 1px solid var(--dots);
  }

  h2 {
    display: flex;
    font-family: Bitter;
    font-weight: bold;
    text-align: center;
    margin: 0;
    padding: 1.5rem 1rem 1rem 1rem;
    font-size: 2rem;
    justify-content: center;
    width: 100%;
    align-items: center;
    font-family: "Open Sans", sans-serif;
    color: transparent;
    font-weight: bold;
    -webkit-text-stroke-width: 1.8px;
    -webkit-text-stroke-color: var(--title);
    text-shadow: 1.5px 1.5px var(--primary);
    border-bottom: 1px solid var(--dots);
  }
  .description {
    background: white;
    box-shadow: var(--shadow);
    border-radius: 1rem;
    margin-bottom: 2rem;
    text-align: center;
    color: var(--title);
  }
</style>
